export default __webpack_public_path__ + "static/media/FHash0.d140fcad.mp3";